import { useModal } from '@trinity/chat-components/components/Modal/index.js';
import { RenameFileModal } from './Modal.RenameFile';

export const useRenameFileModal = () => {
  return useModal(RenameFileModal);
};